interface IFormData {
  uploadImageConfig: {
    fileId?: number;
    fileName?: string;
    fileSize?: string;
    fileExt?: string;
    fileUrl?: string;
  };
  collectionName: string;
  collectionIntro: string;
  tags: string[];
  collectionOpenStatus: boolean;
  id?: string;
}

export interface IEmitsData {
  collectionName: string;
  collectionIntro: string;
  collectionOpenStatus: boolean;
  tags: string[];
  coverImgFileId: number;
  coverImgUrl: string;
  collectionAvailable: number;
  id?: string;
}

const defaultFormData: IFormData = {
  uploadImageConfig: {},
  collectionName: "",
  collectionIntro: "",
  tags: [],
  collectionOpenStatus: false,
  // 支持编辑传入id
  id: "",
};

export const useCollectionDialogStore = defineStore("dialog", {
  state: () => ({
    visible: false,
    loading: false,
    dialogType: "collection",
    formData: {} as IFormData,
    callbacks: {
      onConfirm: null as Function | null,
      onClose: null as Function | null,
    },
    // 是否为编辑模式
    isEdit: false,
  }),
  actions: {
    openDialog(payload: {
      type: "collection";
      isEdit: boolean;
      initData?: Partial<IFormData>;
      onConfirm: (data: any) => void;
      onClose?: () => void;
    }) {
      this.dialogType = payload.type;
      this.formData = {
        ...defaultFormData,
        ...(payload.initData || {}),
      } as IFormData;
      this.callbacks.onConfirm = payload.onConfirm;
      this.callbacks.onClose = payload.onClose || null;
      this.visible = true;
      this.isEdit = !!payload.isEdit;
    },
    handleConfirm(data: IEmitsData) {
      this.loading = true;
      this.callbacks.onConfirm?.(data);
      this.resetState();
    },
    handleClose() {
      this.callbacks.onClose?.();
      this.resetState();
    },
    resetState() {
      this.visible = false;
      this.loading = false;
      this.callbacks = { onConfirm: null, onClose: null };
    },
  },
});
